import { useSelector } from 'react-redux';

import { useTLang } from 'intl/intl';
import ordersSelectors from 'redux/selectors/orders-selectors';
import selectors from '../selectors';

const useAlertText = () => useSelector(selectors.selectAlertText);

const useMaxValue = () =>
  useSelector(ordersSelectors.selectMaxCTFSConfigInOrderDetailDialog);

const useMinValue = () =>
  useSelector(ordersSelectors.selectMinCTFSConfigInOrderDetailDialog);

const useTitle = () => {
  return useTLang({
    id:
      'orderDetailDialogCookingTimeSelectorSection.fullServiceSection.pickingTitle',
  });
};
const useFastOperationText = () => {
  return useTLang({
    id:
      'orderDetailDialogCookingTimeSelectorSection.marketplaceSection.fastOperation',
  });
};
const useDescription = () =>
  useTLang({
    id:
      'orderDetailDialogCookingTimeSelectorSection.fullServiceSection.pickingDescription',
  });

const hooks = {
  useAlertText,
  useMaxValue,
  useMinValue,
  useTitle,
  useFastOperationText,
  useDescription,
};
export default hooks;
